import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { getProtocolList } from "../../Administrations/helpers";
import { AuthenticationOptions, PrivacyOptions, SnmpVersions } from "../../../globals/constants";
import SnmpDrawer from "./SnmpDrawer";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Icon } from "../../../components/Shared/Icon";


const SnmpDetails: React.FC = () => {
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const isSnmpVersionV2c = selectedDevice.snmpVersion?.toString() === '1';
  const [isEditOpen, setIsEditOpen] = useState(false);
  const snmpVersionOptions = getProtocolList(SnmpVersions) || [];
  const snmpVersionLabel = snmpVersionOptions.find((opt) => opt.value === selectedDevice?.snmpVersion?.toString())?.text || "";

  const handleOpenEdit = () => {
    setIsEditOpen(true);
  };

  const handleCloseEdit = () => {
    setIsEditOpen(false);
  };

  const GetPrivacyProtocolName = (value: any) => {
    return PrivacyOptions.find((opt) => opt.value === value)?.name || value;
  };

  const GetAuthenticationProtocolName = (value: any) => {
    return AuthenticationOptions.find((opt) => opt.value === value)?.name || value;
  };

  return (
    <>
      <Card>
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base font-semibold">Connection Details</CardTitle>
            <Button variant="outline" size="sm" onClick={handleOpenEdit}>
              <Icon name="edit" size={14} className="mr-1" />
              Edit
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-6 text-sm">
            <div className="flex flex-col gap-1">
              <span className="text-muted-foreground">IP Address</span>
              <span className="font-medium text-foreground">{selectedDevice?.ipAddress || "—"}</span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-muted-foreground">SNMP Port</span>
              <span className="font-medium text-foreground">{selectedDevice?.port ?? "—"}</span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-muted-foreground">Device UI Port</span>
              <span className="font-medium text-foreground">{selectedDevice?.urlAddress || "443 (default)"}</span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-muted-foreground">Timeout</span>
              <span className="font-medium text-foreground">{selectedDevice?.timeout ?? "—"}</span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-muted-foreground">SNMP Version</span>
              <span className="font-medium text-foreground">{snmpVersionLabel || "—"}</span>
            </div>
            {isSnmpVersionV2c ? (
              <>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Read Community</span>
                  <span className="font-medium text-foreground">{selectedDevice?.readCommunity || "—"}</span>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Write Community</span>
                  <span className="font-medium text-foreground">{selectedDevice?.writeCommunity || "—"}</span>
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Username</span>
                  <span className="font-medium text-foreground">{selectedDevice?.username || "—"}</span>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Context Name</span>
                  <span className="font-medium text-foreground">{selectedDevice?.contextName || "—"}</span>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Authentication Protocol</span>
                  <span className="font-medium text-foreground">{GetAuthenticationProtocolName(selectedDevice?.authProtocol) || "—"}</span>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-muted-foreground">Privacy Protocol</span>
                  <span className="font-medium text-foreground">{GetPrivacyProtocolName(selectedDevice?.privacyProtocol) || "—"}</span>
                </div>
              </>
            )}
          </div>
        </CardContent>
      </Card>
      <SnmpDrawer open={isEditOpen} onClose={handleCloseEdit} />
    </>
  );
};

export default SnmpDetails;